<template>
  <div>
    <div :style="{height: windowHeight}"class="img">
      <div style="color: white;font-size: 4.375rem;">
        <span>下载客户端</span>
      </div>
    </div>
    <div style="display: flex; margin: 4rem 8.5rem 0rem 8.5rem; ">
      
      <div style="  width: 50%; margin: 30px 0; display: flex;justify-content: center;align-items: center;">
        <div :style="{height:contentHeight}" class="contentleft">
          <span style="font-size: 1.875rem;">Android:</span>
          <img src="../assets/phone_a.png"style="position: absolute;right: 0; padding-right: 1.25rem; width: 3.75rem;" />
          <p v-for="(v,k) in info.Android.item">{{k}}:{{v}}</p>
          <div style="display: flex;">
            <p style="flex: 1; color: #000066;cursor: pointer;" @click="download('Android')">下载</p>
            <p style="flex: 1; color: #000066;cursor: pointer;" @click="copy('Android')">复制连接</p>
          </div>
        </div>
      </div>

      <div style="  width: 50%; margin: 30px 0;display: flex;justify-content: center;align-items: center;">
        <div :style="{height:contentHeight}" class="contentleft">
          <span style="font-size: 1.875rem;">IOS:</span>
          <img src="../assets/phone_p.png"style="position: absolute;right: 0; padding-right: 1.25rem; width: 3.75rem;" />
          <p v-for="(v,k) in info.IOS.item">{{k}}:{{v}}</p>
          <div style="display: flex;">
            <p style="flex: 1; color: #000066;cursor: pointer;" @click="download('IOS')">下载</p>
            <p style="flex: 1; color: #000066;cursor: pointer;"@click="copy('IOS')">复制连接</p>
          </div>
        </div>
      </div>

    </div>
    <footerbom style="position: absolute;bottom: 0;"></footerbom>
  </div>
</template>

<script>
  import Footer from '../components/index/public/NavFooter.vue';
  export default{
    data(){
      return{
         windowHeight: document.documentElement.clientHeight*0.2+'px',   //实时屏幕高度
         contentHeight: document.documentElement.clientHeight*0.3+'px',   //实时屏幕高度
         info:{
           IOS:{
              'item':{},
              'status':'0',
              'link':''
           },
           Android:{
             'item':{},
             'status':'0',
             'link':''
           }

         }
      }
    },
    components: {
      footerbom: Footer
    },
    mounted:function(){
      this.get_info()
    },
    methods:{
      get_info(){
        let _this=this
        _this.axios.get('/v2/app/get_info').then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.info=res.data.data
            }else{
              _this.$message.error(res.data.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },

      copy(type){
        let _this=this
        if(_this.info[type].status=='0'){
          _this.$message.error('暂未上架')
        }else{
          let oInput = document.createElement('input')
          oInput.value = _this.info[type].link
          document.body.appendChild(oInput)
          oInput.select()
          document.execCommand("Copy")
          _this.$message.success('复制成功')
          document.body.removeChild(oInput);
        }
      },

      download(type){
        let _this=this
        if(_this.info[type].status=='0'){
          _this.$message.error('暂未上架')
        }else{
          window.open(_this.info[type].link)
        }
      },

     }
  }
</script>

<style>
  .img{
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    background: url(../assets/001.jpg);
  }
  .contentleft {
    width: 40%;
    border-radius: 25px;
    border: 2px solid 	#DBDBDB;
    padding: 20px;
    position: relative;
    overflow-y: auto;
  }
</style>



// WEBPACK FOOTER //
// src/view/client_download.vue